import React from 'react';

const ProgressBar = ({ progress, totalItems }: { progress: number; totalItems: number }) => {
  return (
    <>
      <p className="text-sm text-gray-500">{`${progress}%`}</p>
      <div className=" w-full h-2 bg-gray-200 rounded-full">
        <div
          className="h-full bg-blue-500 rounded-full"
          style={{ width: `${progress || 0}%` }}
        ></div>
        <div className="flex items-center justify-between gap-3">
          <p className="text-sm text-gray-500">Total Items:</p>
          <p className="text-sm text-gray-500">{`${totalItems}`}</p>
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
